import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    directoryNav: {
        /** Aria label for toggling project navigation */
        accessibility: string;
        /** Label when hiding project navigation */
        hide: string;
        /** Label when showing project navigation */
        show: string;
    };
    directoryContent: {
        /** Aria label for toggling the upload links view */
        accessibility: string;
        /** Label when hiding the upload links view */
        hide: string;
        /** Label when showing the upload links view */
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Project navigation panel toggle labels */
            directoryNav: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling project navigation */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryNav.accessibility?c=1bazrwnmy8ccb", defaultMessage: "Toggle the Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding project navigation */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryNav.hide?c=lntz05bdbtl4", defaultMessage: "Hide Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing project navigation */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryNav.show?c=9rg4whmyumvu", defaultMessage: "Show Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Upload links view panel toggle labels */
            directoryContent: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling the upload links view */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryContent.accessibility?c=2oqdsj3wg3kw3", defaultMessage: "Toggle the Upload Links view" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding the upload links view */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryContent.hide?c=m8n8ikfdl2ao", defaultMessage: "Hide the Upload Links view" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing the upload links view */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "uploadLinks.directoryContent.show?c=3ge58bd0wi6g1", defaultMessage: "Show the Upload Links view" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
